import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './features/login/login.component';
import { PortalComponent } from './features/portal/portal.component';
import { LoadErrorComponent } from './features/load-error/load-error.component';
import { AppIdGuard } from './core/guards/app-id.guard';

export const routes: Routes = [
  { path: '', pathMatch: 'full', component: LoginComponent, canActivate: [AppIdGuard] },
  { path: 'portal', pathMatch: 'full', component: PortalComponent, canActivate: [AppIdGuard] },
  { path: 'error/:type', component: LoadErrorComponent },
  { path: 'error', component: LoadErrorComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
